import { Outlet, useParams } from 'react-router-dom';
import { DimensionNav } from '@/components/layout/DimensionNav';
import { ReportProvider } from '@/contexts/ReportContext';

/**
 * InvestorReportLayout
 * Same sidebar + content layout as ReportLayout, but for investor views.
 * Reads tenantId and assessmentId from URL params instead of TenantContext.
 */
export function InvestorReportLayout(): JSX.Element {
  const { tenantId, assessmentId } = useParams<{ tenantId: string; assessmentId: string }>();

  if (!tenantId || !assessmentId) {
    return <div className="p-8 text-center text-destructive">Missing tenant or assessment ID in route.</div>;
  }

  const basePath = `/portfolio/${tenantId}/assessments/${assessmentId}/analysis`;

  return (
    <ReportProvider value={{ tenantId, assessmentId, basePath, isInvestorView: true, hookOptions: { tenantIdOverride: tenantId } }}>
      <div className="flex min-h-0 flex-1">
        <DimensionNav basePath={basePath} />
        <div className="flex-1 overflow-y-auto px-6 lg:px-8 py-6 lg:py-8">
          <div className="max-w-5xl mx-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </ReportProvider>
  );
}
